/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityPasswordInputIcon16Light = forwardRef('SecurityPasswordInputIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.375 8a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z" }),
        React.createElement("path", { d: "M6.5 8.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z" }),
        React.createElement("path", { d: "M10.375 8a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z" }),
        React.createElement("path", { d: "M12.5 8.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 5.5A2.5 2.5 0 0 1 2.5 3h11A2.5 2.5 0 0 1 16 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 10.5v-5ZM2.5 4A1.5 1.5 0 0 0 1 5.5v5A1.5 1.5 0 0 0 2.5 12h11a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 13.5 4h-11Z" })));
});
